export const defaultFirstCursor = 'LTE='